import { decode } from 'jsonwebtoken-esm';
import authorizationCache from 'services/config/authorizationCache';

export function getCurrentAsaasIdentityKey(): string | undefined {
  const token = authorizationCache.storage.getItem(authorizationCache.cacheKey);
  if (!token) return undefined;
  try {
    const payload = decode(token, { json: true }) as Oversea.Token.Payload | null;
    if (!payload?.orgId || !payload.id) return undefined;
    return `${payload.orgId}:${payload.id}`;
  } catch {
    return undefined;
  }
}
